import axios from 'axios';
import { translateApiError } from './salesI18n';

export const SALES_TOKEN_KEY = 'sales_access_token';

export const salesApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/sales`,
});

salesApi.interceptors.request.use((config) => {
  const token = localStorage.getItem(SALES_TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

salesApi.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && localStorage.getItem(SALES_TOKEN_KEY)) {
      localStorage.removeItem(SALES_TOKEN_KEY);
      window.dispatchEvent(new Event('sales-logout'));
    }
    return Promise.reject(err);
  },
);

export function apiError(err, fallback = 'Something went wrong') {
  const detail = err?.response?.data?.detail;
  if (!detail) return translateApiError(err?.message || fallback);
  if (typeof detail === 'string') return translateApiError(detail);
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(' ');
  return translateApiError(detail?.msg || String(detail));
}

export const contractPdfUrl = (contractId) => `${process.env.REACT_APP_BACKEND_URL}/api/sales/contracts/${contractId}/pdf?auth=${encodeURIComponent(localStorage.getItem(SALES_TOKEN_KEY) || '')}`;
export const fileUrl = (fileId, size = 'full') => `${process.env.REACT_APP_BACKEND_URL}/api/sales/files/${fileId}?size=${size}&auth=${encodeURIComponent(localStorage.getItem(SALES_TOKEN_KEY) || '')}`;

// Reduz a foto no cliente (max 1600px, JPEG 0.85) antes de enviar — evita limites de proxy e upload lento no celular
export async function compressImage(file, maxSide = 1600, quality = 0.85) {
  if (!file.type.startsWith('image/')) return file;
  const bitmap = await createImageBitmap(file).catch(() => null);
  if (!bitmap) return file;
  const scale = Math.min(1, maxSide / Math.max(bitmap.width, bitmap.height));
  if (scale === 1 && file.size < 1.5 * 1024 * 1024) return file;
  const canvas = document.createElement('canvas');
  canvas.width = Math.round(bitmap.width * scale);
  canvas.height = Math.round(bitmap.height * scale);
  canvas.getContext('2d').drawImage(bitmap, 0, 0, canvas.width, canvas.height);
  const blob = await new Promise((res) => canvas.toBlob(res, 'image/jpeg', quality));
  return blob ? new File([blob], (file.name || 'photo').replace(/\.[^.]+$/, '') + '.jpg', { type: 'image/jpeg' }) : file;
}
